import React from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";

type Props = {
  handleSubmitOnBoard: () => void;
  toggle: () => void;
};

function AddOnBoardWindow({ handleSubmitOnBoard, toggle }: Props) {
  return (
    <div>
      <ReusableDropdown
        options={[]}
        onChange={(value: any) => {
          console.log("Selected leave type:", value);
          // setSelectedLeaveStatus(value); // Store only the ID as a number
        }}
        DropdownHeading="On Boarding Status"
        //   value={selectedLeaveStatus?.toString()}
      />
      <CustomInput
        label="Start Date"
        type="date"
        //   value={leaveTo}
        style={{
          backgroundColor: "transparent",
          border: "0.2px solid #d4d4d4",
          flex: 1,
        }}
        // onChange={(e) => handleChange(e, "LeaveReason")}
        onChange={(e) => console.log(e, "LeaveTo")}
      />
      <CustomInput
        label="End Date"
        type="date"
        //   value={leaveTo}
        style={{
          backgroundColor: "transparent",
          border: "0.2px solid #d4d4d4",
          flex: 1,
        }}
        // onChange={(e) => handleChange(e, "LeaveReason")}
        onChange={(e) => console.log(e, "LeaveTo")}
      />

      <div style={{ marginTop: "15px" }}>
        <button onClick={handleSubmitOnBoard} className="btn btn-primary">
          Submit
        </button>
        <button
          onClick={() => toggle()}
          className="btn btn-light"
          style={{ color: "gray", marginLeft: "10px" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default AddOnBoardWindow;
